/**
 * invitations (招待リンク受け入れ) の公開ルート定義
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

export const INVITATIONS_PUBLIC_PATHS = {
  pages: [] as const,
  apis: ['/api/invitations/accept'] as const,
} as const
